import React, { createContext, useContext, useEffect, useState } from 'react'
import Cookies from 'universal-cookie';
import { IPvcUser, TPvcCenterAddress } from '../Models/PVC';
import { PERMISSIONS } from '../utils/constant';
interface IAuthState {
  sessionId: string;
}
export interface IAuthContext {
  authState: IAuthState, setAuthState: React.Dispatch<React.SetStateAction<IAuthState>>,
  user: IPvcUser, setUser: React.Dispatch<React.SetStateAction<IPvcUser>>,
  pvcAddresses: TPvcCenterAddress[], setPvcAddresses: React.Dispatch<React.SetStateAction<TPvcCenterAddress[]>>,
}

export const AuthContext = createContext<IAuthContext>({} as IAuthContext)

const cookies = new Cookies()

const initialState = {
  sessionId: cookies.get('sessionId') || ''
}

export const initialUserData: IPvcUser = {
  address: '',
  city: '',
  country: '',
  email: '',
  name: '',
  phone: '',
  pincode: '',
  state: '',
  username: '',
  role: {
    label: '',
    name: '',
    permissions: PERMISSIONS
  }
}

const AuthProvider = (props: any) => {

  const [authState, setAuthState] = useState<IAuthState>(initialState)
  const [user, setUser] = useState<IPvcUser>(initialUserData)
  const [pvcAddresses, setPvcAddresses] = useState<TPvcCenterAddress[]>([])



  return (
    <AuthContext.Provider value={{
      authState, setAuthState,
      user, setUser,
      pvcAddresses, setPvcAddresses
    }}>
      {props.children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
